import * as Scrivito from "scrivito";
import defaultFormInputAttributes from "../../_defaultFormAttributes";

const SelectboxWidget = Scrivito.provideWidgetClass("SelectboxWidget", {
  attributes: {
    ...defaultFormInputAttributes,
    placeholder: "string",

    options: ["widgetlist", { only: "SelectOptionWidget" }],
  },
  onlyInside: "FormPageWidget",
});

export default SelectboxWidget;
